/* ====================================================================
   IMPORTS
   ==================================================================== */

import getCurrentMediaQuery from './_getCurrentMediaQuery';

/* ====================================================================
   HELPERS —> RESIZED
   ==================================================================== */

/**
 * @function resized
 * Debounces the resize event whilst checking if the current media query
 * has changed
 *
 * Documentation:
 * https://code.area17.com/a17/a17-helpers/wikis/resized
 */

const resized = () => {
  let resizeTimer;
  let mediaQuery = getCurrentMediaQuery();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      /**
       * Get the current media query
       */

      const newMediaQuery = getCurrentMediaQuery();

      /**
       * Dispatch a new event denoting that the window has been resized
       */

      window.dispatchEvent(new CustomEvent('resized'));

      /**
       * If the media query has changed, dispatch a new event denoting
       * that the media query has been updated
       */

      if (newMediaQuery !== mediaQuery) {
        mediaQuery = newMediaQuery;
        window.dispatchEvent(new CustomEvent('mediaQueryUpdated'));
      }
    }, 250);
  });
};

export default resized;
